// API Configuration
// Base URL for the API
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.phonevue.in';

// API Endpoints
const API_ENDPOINTS = {
  // Contact endpoints
  CONTACT: {
    SUBMIT: `${BASE_URL}/api/v1/public/contact-us`,
  },

//   Subscribe endpoints
  SUBSCRIBE: {
    SUBSCRIBE: `${BASE_URL}/api/v1/public/subscribe`,
  },
};

// Export the endpoints
export default API_ENDPOINTS;

// Export base URL separately if needed
export { BASE_URL };
